import { CreatePurchaseOrderDto } from "@/core/features/purchase-orders/create-purchase-order.dto";
import { UpdatePurchaseOrderLineDto } from "@/core/features/purchase-orders/update-purchase-order-line.dto";
import { Expose, Type } from "class-transformer";

export class UpdatePurchaseOrderDto extends CreatePurchaseOrderDto {
  @Expose()
  id: string;

  @Expose()
  @Type(() => UpdatePurchaseOrderLineDto)
  lines: UpdatePurchaseOrderLineDto[] = [];
}
